export enum EStavPozadavky {
    ODESLAT = 'ODESLAT',
    ODESLAN = 'ODESLAN',
    CEKAJICI = 'CEKAJICI',
    NEDORUCEN = 'NEDORUCEN',
    PRIPRAVEN = 'PRIPRAVEN',
    ZODPOVEZEN = 'ZODPOVEZEN',
    DORUCEN = 'DORUCEN',
    ZODPSCHYBOU = 'ZODPSCHYBOU',
    POZRUCNE = 'POZRUCNE',
    ZRUSEN = 'ZRUSEN',
    CEKANAZPRAC = 'CEKANAZPRAC'
}
